import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { useUserStore } from "@/stores/userStore";
import InvocationScrollList from "../Workflow/Invocation/InvocationScrollList.vue";
import ActivityPanel from "./ActivityPanel.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InvocationsPanel',
    setup(__props) {
        const { currentUser, toggledSideBar } = storeToRefs(useUserStore());
        return { __sfc: true, currentUser, toggledSideBar, BAlert, InvocationScrollList, ActivityPanel };
    }
});
